import $ from 'jquery';

const customElements = (function () {

    var self = {};
    var cssClass = {
        disabled: 'ca-disabled',
        checked: 'ca-checked',
        label: 'ca-label',
        labelDisabled: 'ca-label-disabled',
        inputSmall: 'ca-small',
        labelSmall: 'ca-label-small'
    };
    var attributesToCopy = ['data-tipped', 'data-tipsy-manual', 'data-tipsy-class', 'data-tipped-pos'];

    self.init = function () {

        // not on new catalog
        if ($("body[data-page='category-new']").length ||
            $("body[data-page='search-new']").length) {
            return;
        }

        // not on new pdp
        if ($("body[data-page='article-new']").length) {
            return;
        }

        $('input[type=checkbox], input[type=radio]')
            .not('[data-dca=true]')
            .not('[data-ignore=true]')
            .not('[data-ca-done=true]')
            .each(function () {
                self.convert($(this));
            });
    };

    /**
     * Method synchronized disabled between real and pseudo element
     */
    self.updateDisabled = function () {
        $('[data-ca-done=true]').each(function () {
            var $this = $(this);
            var $pseudo = $this.prev();
            var $label = $this.siblings('label');

            if ($this.is(':disabled')) {
                $pseudo.addClass(cssClass.disabled);
                $label.addClass(cssClass.labelDisabled);
            } else {
                $pseudo.removeClass(cssClass.disabled);
                $label.removeClass(cssClass.labelDisabled);
            }
        });
    };

    /**
     * @return {home24.helpers.customElements}
     */
    self.updateState = function () {
        $('[data-ca-done=true]').each(function () {
            var $this = $(this);
            var $pseudo = $this.prev();

            if ($this.is(':checked')) {
                $pseudo.addClass(cssClass.checked);
            } else {
                $pseudo.removeClass(cssClass.checked);
            }

        });
    };

    self.rebind = function ($scope = $('body')) {
        $scope.find('[data-ca-done=true]').each(function () {

            var $element = $(this);
            var $pseudo = $element.prev();
            var type = $element.prop('type');

            switch (type) {
                case 'checkbox':
                    $pseudo.off('click');
                    $element.off('change');

                    $pseudo.on('click', function () {
                        self.onPseudoCheckboxClick($pseudo, $element);
                    });

                    $element.on('change', function () {
                        self.onCheckboxChange($element, $pseudo);
                    });
                    break;

                case 'radio':
                    $pseudo.on('click', function () {
                        self.onPseudoRadioClick($pseudo, $element);
                    });

                    $element.on('change', function () {
                        self.onRadioChange($element, $pseudo);
                    });
                    break;

            }
        });
    };

    self.convert = function ($element) {

        var $pseudo = $('<div class="ca"></div>');
        var type = $element.prop('type');
        var $label = $element.siblings('label');
        var i;
        var key;
        var value;
        var pseudoClickCallback;
        var elementChangeCallback;

        $pseudo.addClass('ca-' + type);

        if ($element.is(':disabled')) {
            $pseudo.addClass(cssClass.disabled);
            $label.addClass(cssClass.labelDisabled);
        }

        if ($element.is(':checked')) {
            $pseudo.addClass(cssClass.checked);
        }

        $pseudo.attr('data-ca-value', $element.val());

        /*
         * Copy attributes to pseudo
         */
        for (i in attributesToCopy) {
            if (attributesToCopy.hasOwnProperty(i)) {
                key = attributesToCopy[i];
                value = $element.attr(key);

                if (value) {
                    $pseudo.attr(key, value);
                }
            }
        }

        switch (type) {
            case 'checkbox':
                pseudoClickCallback = 'onPseudoCheckboxClick';
                elementChangeCallback = 'onCheckboxChange';
                break;

            case 'radio':
                pseudoClickCallback = 'onPseudoRadioClick';
                elementChangeCallback = 'onRadioChange';

                $pseudo.attr('data-ca-name', $element.attr('name'));
                break;
        }

        /*
         * Assign pseudo element click event
         */
        $pseudo.on('click', function () {
            self[pseudoClickCallback]($pseudo, $element);
        });

        /*
         * Assign real element change event
         */
        $element.on('change', function () {
            self[elementChangeCallback]($element, $pseudo);
        });

        $pseudo.addClass($element.prop('class'));

        $element.before($pseudo);

        if (type === 'checkbox') {
            // if we just hide the checkbox <label> tag won't select checkbox on click
            $element.css({ position: 'absolute', left: '-99999px' });
        } else {
            $element.addClass('is-hidden');
        }

        // add class to label
        $label.addClass(cssClass.label);

        if ($element.hasClass(cssClass.inputSmall)) {
            $label.addClass(cssClass.labelSmall);
        }

        // mark as converted
        $element.attr('data-ca-done', true);
    };

    self.onPseudoRadioClick = function ($currentTarget, $parent) {

        var $form = $currentTarget.closest('form');

        if (!$currentTarget.hasClass(cssClass.disabled) && !$currentTarget.hasClass(cssClass.checked)) {
            $form.find('[data-ca-name="' + $currentTarget.attr('data-ca-name') + '"]').removeClass(cssClass.checked);
            $currentTarget.addClass(cssClass.checked);
            $form.find('[name="' + $currentTarget.attr('data-ca-name') + '"][value="' + $currentTarget.attr('data-ca-value') + '"]')
                .prop('checked', true)
                .val($currentTarget.attr('data-ca-value'));

            $parent.data('internal-trigger', true);
            $parent.trigger('change');
        }
    };

    self.onRadioChange = function ($source, $pseudo) {

        var $form = $source.closest('form');

        if (!$source.data('internal-trigger')) {
            $form.find('[data-ca-name="' + $source.attr('name') + '"]').removeClass(cssClass.checked);
            $pseudo.addClass(cssClass.checked);
        }
        $source.data('internal-trigger', false);
    };

    self.onCheckboxChange = function ($source, $pseudo) {
        if (!$source.data('internal-trigger')) {
            if ($pseudo.hasClass(cssClass.checked)) {
                $pseudo.removeClass(cssClass.checked);
            } else {
                $pseudo.addClass(cssClass.checked);
            }
        }
        $source.data('internal-trigger', false);
    };

    self.onPseudoCheckboxClick = function ($currentTarget, $parent) {

        if (!$currentTarget.hasClass(cssClass.disabled)) {
            if ($currentTarget.hasClass(cssClass.checked)) {
                $currentTarget.removeClass(cssClass.checked);
                $parent.prop('checked', false);
            } else {
                $currentTarget.addClass(cssClass.checked);
                $parent.prop('checked', true);
            }
            $parent.data('internal-trigger', true);
            $parent.trigger('change');
            $parent.focusout();
        }

    };

    return self;
})();

customElements.init();

function updateState() {
    customElements.updateState();
}
function rebind() {
    customElements.rebind();
}

export {
    updateState,
    rebind
};



/** WEBPACK FOOTER **
 ** ./legacy/home24/helpers/custom-elements.js
 **/